export default {
      id: "giving-statement-usage",
      viewBox: "-2 0 24 26",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#giving-statement",
      toString: function () {
        return this.url;
      }
    }